import ValueRankingActions from './actions';

const INITIAL_STATE = {
  data: {},
  isProcessing: false,
  isError: false,
  errorMessage: [],
  form:{},
  isNewRecord:false,
  typeModal:'form',
  showModal:false,
  onSubmit:false,
  single:null,
  helperRanking:[],
  errorInternal:false
};

export default function ValueRankingReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ValueRankingActions.RESET_LIST:
      return { ...state,errorInternal:false,onSubmit:false, isProcessing: false,single:null, form:INITIAL_STATE.form,data:{}};
    case ValueRankingActions.NEW_DATA:
      return { ...state,errorInternal:false,typeModal:'form',onSubmit:false, isProcessing: false,single:null, errorMessage:[],form:INITIAL_STATE.form,isNewRecord:true,showModal:true};
    case ValueRankingActions.UPDATE_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, single:null,isNewRecord:false};
    case ValueRankingActions.VIEW_DATA:
      return { ...state, errorInternal:false,typeModal:'view',onSubmit:false,isProcessing: false, single:action.payload,errorMessage:[],isNewRecord:false,showModal:true};
    case ValueRankingActions.RESET_DATA:
      return { ...state,errorInternal:false,typeModal:'form',onSubmit:false, isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case ValueRankingActions.DELETE_DATA:
      return { ...state, errorInternal:false,typeModal:'form',onSubmit:false,isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case ValueRankingActions.ON_SUBMIT:
      return { ...state, errorInternal:false,typeModal:'form',onSubmit:true};
    case ValueRankingActions.SHOW_DATA:
      return { ...state, errorInternal:false,typeModal:'view',onSubmit:false, isError: false, data: action.payload, errorMessage: [],isProcessing:false };
    case ValueRankingActions.ERROR_DATA:
      return { ...state, errorInternal:false, isError: true,onSubmit:false,  errorMessage: action.payload,isProcessing:false };
    case ValueRankingActions.SUCCESS_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isError: false, showModal:false,form:INITIAL_STATE.form , onSubmit:false};
    case ValueRankingActions.PROCESS_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: true, isError: false,isSuccess:false};
    case ValueRankingActions.ERROR_SERVER:
      return { ...state,  isError: false, errorInternal:true, onSubmit:false,  errorMessage: action.payload, isProcessing:false };
    case ValueRankingActions.SET_HELPER:
      console.log('branch',action.payload )
      return { ...state,  isProcessing:false,helperRanking:action.payload };
       
    default:
      return state;
    }
}

